var map = {
	"./camera.svg": "2vhn",
	"./close.svg": "toIl",
	"./comment.svg": "SdtW",
	"./down.svg": "LHwD",
	"./edit.svg": "ql+d",
	"./green_star.svg": "YDcb",
	"./like.svg": "JDw2",
	"./location.svg": "WhFt",
	"./plane.svg": "yLYP",
	"./red_star.svg": "V6P4",
	"./search.svg": "Bx0U",
	"./train.svg": "pP09"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 8